export const RPC = 'rpc';
export const UPLOAD = 'upload';
export const DOWNLOAD = 'download';
